import { render, staticRenderFns } from "./SectionContainer.vue?vue&type=template&id=a7d1e0ac&"
import script from "./SectionContainer.vue?vue&type=script&lang=ts&"
export * from "./SectionContainer.vue?vue&type=script&lang=ts&"
import style0 from "./SectionContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports